<template>
  <v-card outlined class="rounded-lg">
    <v-card-title class="text-h6 font-weight-medium">
      Estudios en PDF
      <v-spacer></v-spacer>
      <span class="caption grey--text">Visibles para el paciente en "Mis estudios"</span>
    </v-card-title>
    <v-card-text>
      <v-alert v-if="error" type="error" dense text>{{ error }}</v-alert>

      <v-row dense>
        <v-col cols="12" md="5">
          <v-file-input v-model="file" label="Archivo PDF" accept="application/pdf" outlined dense
                        prepend-icon="mdi-file-pdf-box" show-size :rules="reglaArchivo"></v-file-input>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field v-model="titulo" label="Título (ej: Hemograma)" outlined dense maxlength="200"></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-btn color="primary" depressed block :disabled="!puedeSubir" :loading="subiendo" @click="subir">
            <v-icon left>mdi-upload</v-icon>Subir
          </v-btn>
        </v-col>
      </v-row>

      <v-list v-if="archivos.length" dense>
        <v-list-item v-for="a in archivos" :key="a.id">
          <v-list-item-avatar><v-icon color="red darken-1">mdi-file-pdf-box</v-icon></v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ a.titulo }}</v-list-item-title>
            <v-list-item-subtitle>{{ fecha(a.fecha_carga) }} · {{ tamano(a.tamano) }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action class="flex-row">
            <v-btn icon small @click="descargar(a)" aria-label="Descargar"><v-icon small>mdi-download</v-icon></v-btn>
            <v-btn icon small color="error" @click="eliminar(a)" aria-label="Eliminar"><v-icon small>mdi-delete</v-icon></v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <p v-else class="grey--text mb-0">Sin PDF cargados.</p>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  getArchivosPaciente, subirArchivoPaciente, descargarArchivoPaciente, eliminarArchivoPaciente,
  formatearTamano, mensajeError
} from '@/services/estudiosArchivos';

const MAX_BYTES = 15 * 1024 * 1024;

export default {
  name: 'EstudiosPdf',
  props: {
    pacienteId: { type: [String, Number], default: null }
  },
  data() {
    return {
      archivos: [], file: null, titulo: '', subiendo: false, error: '',
      reglaArchivo: [
        (f) => !f || f.type === 'application/pdf' || 'Debe ser un PDF',
        (f) => !f || f.size <= MAX_BYTES || 'Máximo 15MB'
      ]
    };
  },
  computed: {
    puedeSubir() {
      return !!this.file && this.file.type === 'application/pdf' && this.file.size <= MAX_BYTES;
    }
  },
  watch: {
    pacienteId: { immediate: true, handler() { this.cargar(); } }
  },
  methods: {
    async cargar() {
      if (!this.pacienteId) return;
      try {
        this.archivos = await getArchivosPaciente(this.pacienteId);
      } catch (e) {
        this.error = mensajeError(e, 'No se pudieron cargar los PDF del paciente.');
      }
    },
    async subir() {
      this.subiendo = true;
      this.error = '';
      try {
        await subirArchivoPaciente(this.pacienteId, { file: this.file, titulo: this.titulo });
        this.file = null;
        this.titulo = '';
        await this.cargar();
      } catch (e) {
        this.error = mensajeError(e, 'No se pudo subir el archivo.');
      } finally {
        this.subiendo = false;
      }
    },
    async descargar(archivo) {
      try {
        await descargarArchivoPaciente(this.pacienteId, archivo);
      } catch (e) {
        this.error = 'No se pudo descargar el archivo.';
      }
    },
    async eliminar(archivo) {
      if (!window.confirm(`¿Eliminar "${archivo.titulo}"? El paciente ya no podrá descargarlo.`)) return;
      try {
        await eliminarArchivoPaciente(this.pacienteId, archivo.id);
        await this.cargar();
      } catch (e) {
        this.error = mensajeError(e, 'No se pudo eliminar el archivo.');
      }
    },
    fecha(valor) {
      return valor ? new Date(valor).toLocaleDateString('es-AR') : '';
    },
    tamano: formatearTamano
  }
};
</script>
